var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupTeaching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.32,95.24A24.51,24.51,0,0,0,121.88,70.8H94.94A24.51,24.51,0,0,0,70.5,95.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.96,
    cy: 40.23,
    r: 17.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.05,167h0v19.7H31.49V167h0A18.76,18.76,0,0,1,50.2,149s18-.1,18.87,18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.28,
    cy: 123.73,
    r: 14.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.73,167h0v19.7H88.17V167h0a18.75,18.75,0,0,1,18.69-18s18-.1,18.87,18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106.96,
    cy: 123.73,
    r: 14.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.86,167h0v19.7H145.3V167h0A18.75,18.75,0,0,1,164,149s17.95-.1,18.87,18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 164.09,
    cy: 123.73,
    r: 14.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTeaching);
export default __webpack_public_path__ + "static/media/GROUP_TEACHING.c09b8c81105ea85bab9d3f2a13e7a2b4.svg";
export { ForwardRef as ReactComponent };